<template>
  <div class="body-content validate-wraper">
    <navbar :title="$t('basic.navText')" back="true"></navbar>
    <div class="account-wrapper">
      <div class="slogan-wrapper">
        <span class="slogan-text">{{ $t("basic.slelctCountry") }}</span>
      </div>
      <div class="account-form">
        <div class="form-row">
          <country-com :lang="lang" v-model:countryInfo="countryInfo"/>
        </div>
        <div class="form-row btn-wrap">
          <button class="czur-style" type="button" @click="setCountry">{{ $t("basic.Submit") }}</button>
        </div>
      </div>
      <loading :appear="processing"></loading>
    </div>
<!--    <LoginCheck v-on:nologin="withOutLogin"></LoginCheck>-->
  </div>
</template>
<script>
import Config from 'common/script/config.js'
import loading from 'components/loading/loading'
import navbar from 'components/nav/nav'
import LoginCheck from 'components/loginCheck/loginCheck'
import CountryCom from './countryCom.vue'
import Validate from 'common/script/validate.js'
export default {
  name: 'country',
  props: ['lang'],
  data () {
    return {
      processing: false,
      countryInfo: {},
      changePw: false
    }
  },
  components: {
    loading,
    navbar,
    LoginCheck,
    CountryCom
  },
  methods: {
    setCountry: function () {
      this.processing = true
      this.$http.post(Config.passportHost + '/account/country/update', {
        'u_id': Config.cookieGet(Config.COOKIE_KEY.U_ID),
        'countryCode': this.countryInfo.countryCode
      }).then((response) => {
        this.processing = false
        response = response.body
        if (response.code === 1000) {
          if (this.changePw) {
            Config.setLocalStore('pw', 1)
            this.$router.push({path: '/resetPwd/low'})
            return
          }

          var callback = Config.getReqParam('service')
          if (!Validate.stringEmpty(callback)) {
            callback = Config.appendParam(callback, 'token', Config.cookieGet(Config.COOKIE_KEY.TOKEN))
            callback = Config.appendParam(callback, 'u_id', Config.cookieGet(Config.COOKIE_KEY.U_ID))
            // console.log(callback)
            window.location.href = callback
          } else {
            Config.setLocalStore('request_flag', 1)
            window.location.href = Config.DEFAULT_PAGE
          }
          // Config.setLocalStore('email', this.email)
          // this.$router.push('/updateSuccess')
        }
      })
    }
  },
  created: function () {
    if (this.$route.query.pw === 'true') {
      this.changePw = true
    }
    Config.setLocalStore('request_flag', 0)
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.account-form
  height 4rem
.account-form .form-row.btn-wrap
  margin-top 0.34rem !important
</style>



// WEBPACK FOOTER //
// country.vue?6671e115